export const EMPTY_CLAIM = { status: '' };
export const RISK_NATURE = {
  CORPOREAL: 'Corporels',
};
export const REQUEST_SAGIS_CLAIM_INFO = 'REQUEST_SAGIS_CLAIM_INFO';
export const RESET_SAGIS_CLAIM_INFO = 'RESET_SAGIS_CLAIM_INFO';
export const SET_SAGIS_CLAIM = 'SET_SAGIS_CLAIM';
export const RISK_NAME = {
  CORPOREAL: 'RC - Dommages corporels causés aux tiers',
  MATERIEL: 'RC - Dommages matériels causés aux tiers',
  GARANTIES_ANNEXES: 'Garanties annexes',
};
export const STAKE_HOLDERS_TYPES = {
  IDENTIFIER: '104',
  EXPERT: '103',
  DOCTOR: '7',
  LAWYER: '4',
} as any;
export const STAKE_HOLDERS = {
  IDENTIFIER: 'IDENTIFIER',
  EXPERT: 'EXPERT',
  DOCTOR: 'DOCTOR',
  LAWYER: 'LAWYER',
};
export const LAWYER_INTERVENANT_TYPE = 'Avocat';
export const SET_JUDGEMENT_ON_MERITS_BY_VICTIMS: string =
  'SET_JUDGEMENT_ON_MERITS_BY_VICTIMS';

export const REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VICTIMS: string =
  'REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VICTIMS';

export const REQUEST_GET_REGULATIONS: string = 'REQUEST_GET_REGULATIONS';
export const SET_REGULATIONS: string = 'SET_REGULATIONS';
export const SET_CREATED_REGULATIONS: string = 'SET_CREATED_REGULATIONS';
export const SET_JUDGEMENT_ON_MERITS_BY_VEHICLES: string =
  'SET_JUDGEMENT_ON_MERITS_BY_VEHICLES';
export const SET_CORPOREAL_ENCRYPTED_DOCUMENTS: string =
  'SET_CORPOREAL_ENCRYPTED_DOCUMENTS';
export const SET_MATERIAL_ENCRYPTED_DOCUMENTS: string =
  'SET_MATERIAL_ENCRYPTED_DOCUMENTS';
export const REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VEHICLES: string =
  'REQUEST_GET_JUDGEMENT_ON_MERITS_BY_VEHICLES';
export const REQUEST_CREATE_CORPO_ENCRYPTED_DOCUMENT =
  'REQUEST_CREATE_CORPO_ENCRYPTED_DOCUMENT';
export const REQUEST_MATERIAL_ENCRYPTED_DOCUMENT =
  'REQUEST_MATERIAL_ENCRYPTED_DOCUMENT';
export const REQUEST_CREATE_CORPOREAL_REGULATION =
  'REQUEST_CREATE_CORPOREAL_REGULATION';
export const REQUEST_CREATE_MATERIAL_REGULATION =
  'REQUEST_CREATE_MATERIAL_REGULATION';
export const REQUEST_CREATE_ADDITIONAL_WARRENTIES_REGULATION =
  'REQUEST_CREATE_ADDITIONAL_WARRENTIES_REGULATION';
export const REQUEST_CREATE_SUMMARY_SHEET_REGULATION =
  'REQUEST_CREATE_SUMMARY_SHEET_REGULATION';
export const AUTO_COMPLETE_REMOVE_OPTION = 'remove-option';
export const AUTO_COMPLETE_CLEAR_OPTION = 'clear';
export const AUTO_COMPLETE_SELECT_OPTION = 'select-option';
export const REQUEST_GET_ASSIGNED_LAWYERS: string =
  'REQUEST_GET_ASSIGNED_LAWYERS';
export const SET_ASSIGNED_LAWYERS: string = 'SET_ASSIGNED_LAWYERS';
export const UPLOAD_DOCUMENT_REGULATION: string = 'UPLOAD_DOCUMENT_REGULATION';
export const REQUEST_GET_REGULATION: string = 'REQUEST_GET_REGULATION';
export const REQUEST_VALIDATE_PROVISION: string = 'REQUEST_VALIDATE_PROVISION';
export const SET_REGULATION: string = 'SET_REGULATION';
export const REQUEST_VALIDATE_REGULATION: string =
  'REQUEST_VALIDATE_REGULATION';
